import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query candidateNotesById($id: MongoID!) {
    cat {
      candidate {
        byId(_id: $id) {
          _id
          notes
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type CandidateNotesById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['candidate']>['byId']>

const useCandidateNotesById = (id: string): CandidateNotesById | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'string'
  })
  const candidate = data?.cat?.candidate?.byId ?? undefined
  return candidate
}

export { useCandidateNotesById, document as candidateNotesByIdDocument }
